<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    max-width="50rem"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn icon small v-on="{ ...dialog }">
        <v-icon small>fa-ellipsis-h</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="end" no-gutters>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text class="dense-table">
        <InventoryWarningChart show-over-min></InventoryWarningChart>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import InventoryWarningChart from "./InventoryWarningChart";
export default {
  name: "InventoryWarningDialog",
  components: {
    InventoryWarningChart
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style></style>
